import 'slick-carousel';
const TABLET_WIDTH = 1024
const MOBILE_WIDTH = 768
const $sliderSlides = $('.js-slider-product .js-slider-product-slides')
const sliderSlidesStartImage = $sliderSlides.data('start-image-src')
const $sliderThumbs = $('.js-slider-product .js-slider-product-thumbs')
let slideIndex = 0

if (sliderSlidesStartImage !== undefined && sliderSlidesStartImage !== '') {
  const $slideImageTarget = $sliderSlides.find(`[data-slide-index][data-slide-image-src="${sliderSlidesStartImage}"]`)
  if ($slideImageTarget.length) {
    slideIndex = parseInt($slideImageTarget.data('slide-index'))
  }
}

$sliderSlides.slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: false,
  initialSlide: slideIndex,
	asNavFor: $sliderThumbs
});

$sliderThumbs.slick({
	slidesToShow: 5,
	slidesToScroll: 1,
	dots: false,
	arrows: true,
	infinite: false,
  initialSlide: slideIndex,
	asNavFor: $sliderSlides,
	focusOnSelect: true,
	responsive: [
    {
      breakpoint: MOBILE_WIDTH,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});
